import { render, staticRenderFns } from "./createAddress.vue?vue&type=template&id=26924460"
import script from "./createAddress.vue?vue&type=script&lang=ts"
export * from "./createAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports